export default __webpack_public_path__ + "static/media/Countdown_2.bddba161.png";